export default "__VITE_ASSET__5c40dda1__"